import { useRef } from 'react';
import { useLocation } from '@remix-run/react';
import { extractAdvertRequestUrlContext } from '@modules/adverts/utils/utils';

/**
 * 'Memo' a set of data for a given path.
 */
export const useLocationMemo = <T>(
    data: T[],
    pathContext: string[] = [],
): T[] => {
    const dataRef = useRef(data);
    const location = useLocation();
    const lastPath = useRef(location.pathname);

    // Add any path context if matching keys to the memo key
    let memoKey = location.pathname;
    if (pathContext.length && location.search) {
        // The domain doesn't matter, simply using to build a URL object.
        const pathMemoContext = extractAdvertRequestUrlContext(
            new URL(
                'https://archipro.co.nz' + location.pathname + location.search,
            ),
            pathContext,
        );
        if (Object.keys(pathMemoContext).length) {
            memoKey += Object.values(pathMemoContext).join('-');
        }
    }

    if (lastPath.current !== memoKey) {
        dataRef.current = data;
        lastPath.current = memoKey;
    }
    return dataRef.current;
};
